import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';

const Actions = ({ rowData }) => {
    const navigate = useNavigate();

    return (
        <span className="flex justify-center items-center">
            <Tooltip
                title="مشاهده پیام‌های تیکت"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => navigate("/tickets/context", {
                        state: rowData
                    })}
                >
                    <QuestionAnswerIcon className="text-green-500" />
                </IconButton>
            </Tooltip>
            <Tooltip
                title="ویرایش نقش گیرندگان تیکت"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => navigate("/tickets/edit-ticket-roles", {
                        state: rowData
                    })}
                >
                    <PsychologyAltIcon className="text-blue-500" />
                </IconButton>
            </Tooltip>
            <Tooltip
                title="تغییر وضعیت تیکت"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => navigate("/tickets/edit-ticket-status", {
                        state: rowData
                    })}
                >
                    <EditIcon className="text-yellow-400" />
                </IconButton>
            </Tooltip>
        </span>
    );
}

export default Actions;
